import { collection, getDoc, getDocs, doc, newId } from '@battleops/localstore';
import { normalizeRoutine, routineVisible, matchesEvent, nextSlot, localDateStr, commands } from '@battleops/shared';
import { db } from './store';
import { commitWrites } from './commit';
import { currentUid } from '../session/boot';

// Routine event triggers (docs/plans/routines.md): clock in / out, a task done, arriving at / leaving a job, the first
// phone unlock, another routine finished. A matching routine gets today's run made now (status due, dueAt = the event)
// — the reminder pipeline then rings it (shared routineRings: runs made by an event ring when they were made; "after"
// ones stay quiet, the finish screen offers them). One run per routine a day unless it allows more (nextSlot).
// Reads the store, so it works from any context (TaskContext, LocationContext, the app shell). Fire-and-forget.
const read = async (name) => (await getDocs(collection(db, name))).docs.map((d) => ({ id: d.id, ...d.data() }));

export async function fireRoutineEvent(event = {}) {
  try {
    const at = Number(event.at) || Date.now();
    const ev = { ...event, at };
    if (ev.type === 'task_done' && ev.taskId) {
      const t = await getDoc(doc(db, 'tasks', ev.taskId)).catch(() => null);
      if (t?.exists?.() && t.data()?.runId) return [];   // a routine's own step never fires routines
    }
    const uid = currentUid();
    const raw = await read('processes');
    if (!raw.length) return [];
    let runs = await read('processExecutions');
    const date = localDateStr(at);
    const made = [];
    for (const p of raw) {
      const r = normalizeRoutine(p);
      if (!r || !routineVisible(r, uid) || !r.steps.length) continue;
      const trig = matchesEvent(r, ev);
      if (!trig) continue;
      const n = nextSlot(r, runs, date, uid);
      if (!n) continue;
      const res = commands.materializeRun({ routines: raw, runs, uid, now: at, newId }, {
        routineId: r.id, date, n, dueAt: at,
        trigger: { type: ev.type, at, ...(ev.projectId ? { projectId: ev.projectId } : {}) },
      });
      if (!res.created) continue;
      await commitWrites(res.writes);
      runs = [...runs, res.run];
      made.push(res.run);
    }
    return made;
  } catch (e) {
    console.error('routine event failed:', e);
    return [];
  }
}
